export const getUserState = (state) => state.user;
export const getPhotoState = (state) => state.photo;
export const getProfileState = (state) => state.profile;
export const getGalleryState = (state) => state.gallery;
export const getIndividualRatingState = (state) => state.individualRating;
export const getViewPhotoState = (state) => state.viewPhoto;
export const getNotifications = (state) => state.notification;
export const getAdminState = (state) => state.admin;